import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import type { IResourceModel } from '@/shared/model/briefing-widget.model';
import moment from 'moment';
import ResourceFooterComponent from '@/shared/cards/briefing/resource/components/resource-footer/resource-footer.vue';
import { formatDateAgo } from '@/util/date-util';
import { fetchYoutubeThumbnail, convertToEmbedUrl } from '@/util/video-util';

@Component({
  methods: { fetchYoutubeThumbnail, formatDateAgo },
  components: {
    'resource-footer': ResourceFooterComponent,
  },
  computed: {
    moment() {
      return moment;
    },
    isContentNew() {
      return this.formModel && this.formModel.isNew;
    },
  },
})
export default class VideoWidget extends Vue {
  @Prop(Object) readonly formModel: IResourceModel;
  @Prop(Boolean) readonly isHideOptions: boolean;
  @Prop(Boolean) readonly isHideHidden: boolean;
  @Prop(Boolean) readonly isHideGoover: boolean;
  @Prop(Boolean) readonly isHideShared: boolean;
  @Prop(Boolean) readonly isHideAddReference: boolean | false;

  @Emit('share') share() {}

  @Emit('hide') hide() {}

  @Emit('select-user-social') selectUserSocial() {}

  @Emit('view-detail') viewDetail() {}

  @Emit('toggle-resource') toggleResource() {}

  @Emit('add-to-reference') addToReference() {}

  @Emit('goover') goover() {}

  videoUrl = '';

  mounted() {
    this.videoUrl = this.formModel?.videoUrl || this.formModel?.originParentDocDetail?.source_uri || this.formModel?.url || '';

    if (this.videoUrl) {
      this.videoUrl = convertToEmbedUrl(this.videoUrl);
    }
  }
}
